import { z } from 'zod'

import { FormContext } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'
import { createNodeSidepanelSchema } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'

export const createApprovalFormSchema = (formContext: FormContext) =>
  createNodeSidepanelSchema(formContext).extend({
    nodeType: z.literal('approvals'),
    nodeData: z.object({
      handlerType: z.string(),
      payload: z.object({}),
    }),
  })

export type ApprovalFormSchema = z.infer<ReturnType<typeof createApprovalFormSchema>>
